"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Rss = void 0;
var _react = _interopRequireDefault(require("react"));
var Rss = exports.Rss = function Rss() {
  return _react["default"].createElement("svg", {
    width: "16",
    height: "17",
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react["default"].createElement("path", {
    d: "M4.5 13.875C4.5 12.6445 3.48047 11.625 2.25 11.625C0.984375 11.625 0 12.6445 0 13.875C0 15.1406 0.984375 16.125 2.25 16.125C3.48047 16.125 4.5 15.1406 4.5 13.875ZM10.6523 15.5625C10.3711 10.1133 6.01172 5.75391 0.5625 5.47266C0.246094 5.4375 0 5.71875 0 6.03516V7.72266C0 8.00391 0.210938 8.25 0.492188 8.28516C4.42969 8.53125 7.59375 11.6953 7.83984 15.6328C7.875 15.9141 8.12109 16.125 8.40234 16.125H10.0898C10.4062 16.125 10.6875 15.8789 10.6523 15.5625ZM15.7148 15.5625C15.4336 7.33594 8.82422 0.691406 0.5625 0.410156C0.246094 0.375 0 0.621094 0 0.972656V2.66016C0 2.94141 0.210938 3.1875 0.527344 3.22266C7.24219 3.46875 12.6562 8.88281 12.9023 15.5977C12.9375 15.9141 13.1836 16.1602 13.4648 16.1602H15.1523C15.5039 16.125 15.75 15.8789 15.7148 15.5625Z",
    fill: "white"
  }));
};